









































import { Vue, Component } from 'vue-property-decorator'
import { darkMode, miniNav } from '@/services/app'
import { DarkPreference } from '@/util/theme'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import { showToast } from '@/services/app'
import { registerNotifications } from '@/services/notifications'

@Component({
  metaInfo: {
    title: 'Settings - Preferences'
  },
})
export default class Preferences extends Vue {

  permissionStatus = ''
  darkPreferenceOptions = [
    {
      text: 'System default',
      value: 'default',
    },
    {
      text: 'Light',
      value: 'light',
    },
    {
      text: 'Dark',
      value: 'dark',
    },
  ]

  async mounted() {
    if (!Capacitor.isNativePlatform()) return
    const { receive } = await PushNotifications.checkPermissions()
    this.permissionStatus = receive
  }


  get preferences() {
    return this.$store.state.app.preferences
  }

  get pushNotificationsAvailable() {
    return Capacitor.isPluginAvailable('PushNotifications')
  }
  
  async enablePushNotifications() {
    const { receive } = await PushNotifications.checkPermissions()
    
    switch (receive) {
      case 'denied':
        showToast(this.$store, {
          text: 'Push notifications are disabled. Please enable them in your device settings.',
        })
        break
      
      default:
        // TODO:
        registerNotifications()
        break
    }
  }

  updateDarkMode() {
    darkMode.set(this.$store, this.preferences.darkMode as DarkPreference)
  }

  updateMiniNav() {
    miniNav.toggle(this.$store, this.preferences.miniNav)
  }
}
